import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {renderIf} from "../../../Shared";
import {GoDotFill} from "react-icons/go";
import classNames from "classnames";
import {AttendanceActionTypes} from "../../../AppLocals/Course";
import dayjs from "dayjs";

export const renderCourseClassAttendance = ({renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {

    const {total_students, total_attendance, subject, number_of_sessions, attendance_date, can_checkin} = item ?? {}

    const dateObj = attendance_date ? dayjs(attendance_date) : null

    const percent_num = total_students > 0
        ? parseFloat(((total_attendance / total_students) * 100).toFixed(1))
        : 0
    const percent_session = total_students > 0
        ? percent_num.toFixed(1)
        : null

    let barColor = 'bg-color-100'
    let percentColor = 'text-color-300'
    let borderColor = 'border-color-100'
    let bgColor = 'background-100'

    if (percent_num >= 75) {
        barColor = 'bg-green-500'
        percentColor = 'text-green-500'
        borderColor = 'border-green-400'
        bgColor = 'bg-green-50 text-green-600'
    } else if (percent_num >= 50) {
        barColor = 'bg-blue-500'
        percentColor = 'text-blue-500'
        borderColor = 'border-blue-400'
        bgColor = 'bg-blue-50 text-blue-600'
    } else if (percent_num > 0) {
        barColor = 'bg-red-400'
        percentColor = 'text-red-500'
        borderColor = 'border-red-400'
        bgColor = 'bg-primary-50 text-primary-600'
    }

    return (
        <Translate key={index}>
            {(t) => (
                <div
                    className={classNames(
                        "p-3 flex items-center gap-3 custom-item-render relative list-item",
                        !can_checkin && 'opacity-40 cursor-not-allowed'
                    )}>
                    {/* Date badge */}
                    {dateObj ? (
                        <div
                            style={{width: 46, height: 46}}
                            className={classNames(
                                "px-2 py-1.5 flex flex-col flex-center rounded-lg flex-shrink-0",
                                borderColor, bgColor, percent_num >= 50 ? 'border-2' : 'border'
                            )}>
                            <span className="font-bold text-base leading-none">
                                {dateObj.format('DD')}
                            </span>
                            <span className="mt-0.5 text-2xs text-color-300 leading-tight tracking-wide">
                                {dateObj.format('MM/YY')}
                            </span>
                        </div>
                    ) : (
                        <div
                            className="px-2 py-1.5 flex flex-col flex-center border border-color-50 background-50 rounded-lg flex-shrink-0"
                            style={{width: 46, height: 46}}>
                            <span className="text-xs text-color-300">—</span>
                        </div>
                    )}

                    {/* Title + subject */}
                    <div className="flex-1 min-w-0 flex flex-col gap-0.5">
                        <span
                            onClick={() => can_checkin ? handleAction(AttendanceActionTypes.DETAIL, item) : null}
                            className={classNames(
                                "font-bold text-sm text-color-000 truncate",
                                can_checkin && 'hover:text-primary cursor-pointer'
                            )}>
                            {getTitle(item)}
                        </span>
                        {subject && (
                            <div className="flex items-center gap-1 text-xs text-color-300 whitespace-no-wrap">
                                {/*<span className="font-medium truncate">*/}
                                {/*    {getTitle(subject)}*/}
                                {/*</span>*/}
                                <GoDotFill size={8} className="ml-2 text-slate-400 flex-shrink-0"/>
                                <span className="font-bold text-slate-600">
                                    {number_of_sessions}
                                </span>
                                {t('sessions')}
                            </div>
                        )}
                    </div>

                    {/* Attendance stats */}
                    {total_students > 0 && (
                        <div className="flex flex-col items-end gap-0.5 md:gap-1 flex-shrink-0">
                            <div className="flex flex-col md:flex-row items-end md:items-center gap-0.5 md:gap-2">
                                <div
                                    style={{width: 80}}
                                    className="h-1.5 rounded-full overflow-hidden bg-color-50">
                                    <div
                                        className={classNames("h-full rounded-full transition-all", barColor)}
                                        style={{width: `${Math.min(percent_num, 100)}%`}}
                                    />
                                </div>
                                <span className={classNames("font-bold text-xs w-12 text-right", percentColor)}>
                                    {percent_session}%
                                </span>
                            </div>
                            <span className="text-2xs text-color-300 italic">
                                {`${total_attendance}/${total_students} ${t('students')}`}
                            </span>
                        </div>
                    )}

                    {renderIf(
                        item?.course_class?.edit && renderContextMenu,
                        <div className="mb-auto contextIcon flex-shrink-0">
                            {renderContextMenu(item)}
                        </div>
                    )}
                </div>
            )}
        </Translate>
    )
}
